import React from 'react';

export const RuPeriodModal = {
  title: 'Period',
  body: (
    <div>
      <p>
        The period is in minutes and, when available, is the period of the first cycle.
      </p>
    </div>
  ),
};
